export type CatalogKind = 'manga' | 'anime' | 'live';
export interface BuiltinSource { id: string; name: string; type: CatalogKind; website: string; icon?: string }
export const BUILTIN_SOURCES: BuiltinSource[] = [
  {id:'mangadex',name:'MangaDex',type:'manga',website:'https://mangadex.org'},
  {id:'leercapitulo',name:'LeerCapítulo',type:'manga',website:'https://leercapitulo.co'},
  {id:'kazokuden',name:'Kazoku Den',type:'manga',website:'https://kazokuden.com'},
  {id:'anzmanga',name:'AnzManga',type:'manga',website:'https://www.anzmanga25.com'},
  {id:'dbnewhope',name:'DB New Hope',type:'manga',website:'https://dbnewhope.com'},
  {id:'marmota',name:'Marmota',type:'manga',website:'https://marmota.me'},
  {id:'enchiladascan',name:'EnchiladaScan',type:'manga',website:'https://enchiladascan.github.io'},
  {id:'olympusscanlation',name:'Olympus Scanlation',type:'manga',website:'https://olympusxyz.com'},
  {id:'inmanga',name:'InManga',type:'manga',website:'https://inmanga.com'},
  {id:'novelcool',name:'NovelCool',type:'manga',website:'https://es.novelcool.com'},
  {id:'mangaplus',name:'MANGA Plus',type:'manga',website:'https://mangaplus.shueisha.co.jp'},
  {id:'animeav1',name:'AnimeAV1',type:'anime',website:'https://animeav1.com'},
  {id:'animeflvor',name:'AnimeFLV',type:'anime',website:'https://animeflv.or.at'},
  {id:'animeyt',name:'AnimeYT',type:'anime',website:'https://animeyt.cc'},
  {id:'anizone',name:'AniZone',type:'anime',website:'https://anizone.to'},
  {id:'katanime',name:'Katanime',type:'anime',website:'https://katanime.net'},
  {id:'monoschinos',name:'MonosChinos',type:'anime',website:'https://monoschinos.st'},
  {id:'animeflv',name:'AnimeFLV',type:'anime',website:'https://www3.animeflv.net'},
  {id:'jkanime',name:'JKAnime',type:'anime',website:'https://jkanime.net'},
  {id:'nowfutbol',name:'NowFutbol',type:'live',website:'https://nowfutbol.xyz'},
  {id:'argentinatv',name:'Argentina TV',type:'live',website:'https://www.mitelefe.com'},
];
